import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  registrationContainer: {
    background: "#fff",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    width: "575px",
    minHeight: "229px",
    border: "1px solid #CCCCCC",
    borderRadius: "4px",
  },
  form: {
    display: "flex",
    background: "#fff",
    flexDirection: "column",
    fontSize: '14px',
    "& .MuiOutlinedInput-input": {
      color: "#333",
      '&::placeholder': {
        color: '#666'
      }
    },
    "& .MuiSelect-select": {
      fontSize: "14px",
      color: "#333",
      '&::placeholder': {
        color: '#666'
      }
    },
    "& h5": {
      padding: 0,
      marginBottom: "0.75rem",
      fontSize: "1rem",
      color: "#666",
    },
  },
  inputContainer: {
    marginTop: "1.5rem",
    width: "100%",
    padding: "0 2rem",
    "& .MuiFormControl-root": {
      width: "100%",
    },
    "& .firstname": {
      width: "48%",
    },
    "& .lastname": {
      width: "48%",
    },
  },
  inputContainerCountry: {
    display: "flex",
    marginTop: "1.5rem",
    padding: "0 2rem",
    gap: "24px",
  },
  country: {
    fontSize: '14px',
    width: "336px",
  },
  uf: {
    width: "160px",
  },
  info: {
    padding: "1rem 2rem",
    fontSize: "12px",
    color: "#666",
    "& a": {
      color: "#007582",
      fontWeight: 700,
      textDecoration: "none",
    },
  },
  citySelect: {
    "& svg": {
      color: "red",
      animation: "$spin 2s linear infinite",
    },
  },
  "@keyframes spin": {
    from: {
      transform: "rotate(0deg)",
    },
    to: {
      transform: "rotate(360deg)",
    },
  },
  confirm: {
    color: "#666",
    padding: "0 1.44rem",
    display: "flex",
    alignItems: "center",
  },
  confirmText: {
    fontSize: "14px",
  },
  actionButtons: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#fff",
    padding: "16px 24px",
    marginTop: "1rem",
    borderTop: "1px solid #ccc",
    "& .goNext": {
      display: "flex",
      alignItems: "center",
      fontSize: "10px",
      color: "#666666",
      fontWeight: 700,
      gap: "10px",
    },
    "& .goBack": {
      border: "2px solid #26975A",
      color: "#26975A",
      height: "32px",
      "& svg": {
        fontSize: "12px",
      },
    },
    "& .next": {
      background: "#26975A",
      color: "#FFF",
      height: "32px",
    },
    "& .Mui-disabled": {
      background: "#EEE",
      color: "#999",
    },
  },
}));

export default useStyles;
